module.exports = __webpack_public_path__ + "img/dark_left_tag.89659a19.png";